import { Route, Routes } from 'react-router-dom'
import LogoutPage from '../auth/LogoutPage'
import ListProductsPage from '../products/ListProductsPage'
import ProductFormPage from '../products/ProductFormPage'
import CanadianLdsEntryPage from '../labelDeclarationSheets/ca/CanadianLdsEntryPage'
// import CanadianLdsSupplementedEntryPage from '../labelDeclarationSheets/ca/CanadianLdsSupplementedEntryPage'
import LdsEntryPage from '../labelDeclarationSheets/us/LdsEntryPage'
import ListGenesisFormulasPage from '../genesis/ListGenesisFormulasPage'
import ListActiveLdsPage from '../labelDeclarationSheets/ListActiveLdsPage'
import GenesisFormulaViewerPage from '../genesis/GenesisFormulaViewerPage'
import ListUsersPage from '../users/ListUsersPage'
import UserFormPage from '../users/UserFormPage'
import HomePage from '../home/HomePage'
import { ROLES } from '../auth/role'
import RoleContext from '../auth/RoleContext'
// import { FeatureFlags } from '../config/config'

export default function Body(props = {}) {
  return (
    <RoleContext.Consumer>
      {roleCtx => (
        <div className="content-wrapper">
          <section className="content body">
            <div className="row">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/logout" element={<LogoutPage />} />
                <Route path="/label-declaration-sheets/regulation/:regulationId" element={<ListActiveLdsPage />} />
                <Route path="/label-declaration-sheets/us/products/:id/entry" element={<LdsEntryPage />} />
                <Route path="/label-declaration-sheets/ca/products/:id/entry" element={<CanadianLdsEntryPage />} />
                {
                  roleCtx.hasRole([ROLES.ADMIN, ROLES.SRA_ADMIN, ROLES.SRA_USER]) &&
                  <>
                    <Route path="/genesis" element={<ListGenesisFormulasPage />} />
                    <Route path="/genesis/recipes/:id" element={<GenesisFormulaViewerPage />} />
                  </>
                }
                {
                  roleCtx.hasRole([ROLES.ADMIN, ROLES.SRA_ADMIN]) &&
                  <>
                    <Route path="/users/list" element={<ListUsersPage />} />
                    <Route path="/users/edit/:koId" element={<UserFormPage />} />
                  </>
                }
              </Routes>
            </div>
          </section>
        </div>
      )}
    </RoleContext.Consumer>
  )
}
